import { jsx as a, jsxs as b } from "react/jsx-runtime";
import { forwardRef as le, useState as f, useEffect as S, useContext as de, useRef as te, useCallback as ne } from "react";
import { C as v, n as Fe, aE as He, b5 as je, s as O, a0 as U, ag as G, Q as ze, v as me, w as pe, O as ue, E as ye, a4 as ge, bg as Pe, o as Ge, A as Y, at as V, bh as _e, bi as oe, F as Ce, t as qe, bj as be, bc as W, an as he, T as Z, bk as Ne, h as Ye, bl as We, bm as Ze, bn as Ke, z as Xe, aP as Je, g as xe, u as et } from "./helpers-458d7e27.js";
import y from "clsx";
import { Q } from "./card-renderer-3ad4b108.js";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
const tt = {
  "sticky-container": "_sticky-container_w8tfx_1",
  "sticky-container-position-bottom": "_sticky-container-position-bottom_w8tfx_8",
  "sticky-container-position-top-right": "_sticky-container-position-top-right_w8tfx_11",
  "sticky-container-position-top-left": "_sticky-container-position-top-left_w8tfx_21",
  "sticky-container-position-bottom-right": "_sticky-container-position-bottom-right_w8tfx_31",
  "sticky-container-position-bottom-left": "_sticky-container-position-bottom-left_w8tfx_41",
  "sticky-container-position-top-center": "_sticky-container-position-top-center_w8tfx_51",
  "sticky-container-position-bottom-center": "_sticky-container-position-bottom-center_w8tfx_61"
}, ke = "StickyContainer", ae = new v(ke, tt), fe = le(
  ({ className: n, position: t = "bottom right", children: e, style: o, options: s, ...i }, c) => {
    const r = y(
      ae.getComponentClassName(),
      ae.getPropsValueClassName("position", Fe(t)),
      n
    );
    return /* @__PURE__ */ a(
      "div",
      {
        ref: c,
        className: r,
        style: He({
          "--xy-spacing": s == null ? void 0 : s.xySpacing,
          "--xy-spacing-xl": s == null ? void 0 : s.xySpacingXL,
          ...o
        }),
        ...i,
        children: e
      }
    );
  }
);
fe.displayName = ke;
const nt = (n) => {
  const [t, e] = f(!1), o = () => {
    const s = document.getElementById(n);
    if (!s) {
      e(!0);
      return;
    }
    const i = s == null ? void 0 : s.getBoundingClientRect(), c = (i == null ? void 0 : i.top) <= window.innerHeight;
    e(!c);
  };
  return S(() => {
    o();
  }, []), je(o), { showQrCode: t, setShowQrCode: e };
}, q = {
  enter: "enter",
  leave: "leave",
  none: ""
}, ot = "sticky-qr-badge", d = {
  bodyTextSection: "body-text-section",
  bodyTextWrapper: "body-textwrapper",
  bodyText: "body-text",
  bodyTextBackground: "body-text-background",
  qrCodeSection: "qr-code-section",
  qrCodeText: "primary-text",
  qrCodeSectionBackground: "qr-code-section-background"
}, at = 0.5, st = {
  duration: 0.8,
  ease: "easeInOut"
}, it = {
  large: 110,
  small: 84
}, ct = ({
  isXlAndAbove: n,
  hoverState: t
}) => {
  const { environment: { isRTL: e = !1 } = {} } = O();
  return { animationVariant: {
    [d.qrCodeText]: {
      initial: { opacity: 0 },
      onLoad: { opacity: 0 },
      onScroll: { opacity: 1 }
    },
    [d.qrCodeSectionBackground]: {
      initial: { scaleY: 0.75 },
      onLoad: { scaleY: 0.75 },
      onScroll: { scaleY: 1 }
    },
    [d.qrCodeSection]: {
      initial: { x: 0 },
      onLoad: { x: e ? 8 : -8 },
      onScroll: {
        x: n ? 8 : 0,
        y: n ? -16 : -18
      }
    },
    [d.bodyText]: {
      initial: {
        opacity: 0,
        x: n ? 16 : 8
      },
      onLoad: {
        opacity: 1,
        x: 0,
        transition: t === q.enter ? {
          delay: 0.8,
          duration: 0.8
        } : {
          delay: 1,
          duration: 0.8
        }
      },
      onScroll: {
        opacity: 0,
        x: n ? 16 : 8,
        transition: {
          delay: 0,
          duration: 0.5
        }
      }
    },
    [d.bodyTextBackground]: {
      initial: { scale: 0 },
      onLoad: { scale: 1 },
      onScroll: { scale: 0 }
    }
  } };
}, rt = {
  "qr-component": "_qr-component_1efju_2",
  "qr-component-body-text-section": "_qr-component-body-text-section_1efju_8",
  "qr-component-body-text-background": "_qr-component-body-text-background_1efju_15",
  "qr-component-body-text-wrapper": "_qr-component-body-text-wrapper_1efju_29",
  "qr-component-body-text": "_qr-component-body-text_1efju_8",
  "qr-component-qr-code-section": "_qr-component-qr-code-section_1efju_46",
  "qr-component-qr-code-section-background": "_qr-component-qr-code-section-background_1efju_55",
  "qr-component-qr-code-image-wrapper": "_qr-component-qr-code-image-wrapper_1efju_66",
  "qr-component-qr-code-wrapper": "_qr-component-qr-code-wrapper_1efju_71",
  "qr-component-qr-code": "_qr-component-qr-code_1efju_46",
  "qr-component-qr-code-text": "_qr-component-qr-code-text_1efju_91"
}, K = "QrComponent", C = new v(K, rt), lt = U.a, A = U.div, Se = ({
  className: n,
  qrCodeText1: t = "",
  text: e,
  imageUrl: o,
  imageAltText: s = "",
  url: i,
  componentId: c = ot,
  analyticsCompName: r = K,
  scrollDirection: m,
  dataQrUrl: l,
  serverFptiData: p,
  ...u
}) => {
  const g = y(C.getComponentClassName(), n), {
    environment: { pageSegment: N = "", baseURI: T = "" } = {},
    requestor: { locality: { country: w = "" } = {} } = {}
  } = O(), M = G(e), [E, x] = f(!0), [_, $e] = f(""), [De] = ze(["Below XL"]), { animationVariant: h } = ct({
    isXlAndAbove: !De,
    hoverState: _
  }), Oe = {
    [q.enter]: 0.1,
    [q.leave]: 0
  }, Ue = me(
    {
      linkText: t,
      componentName: r,
      linkType: ue.Tertiary,
      clickEvent: ye.GetTheApp,
      serverFptiData: p
    },
    N,
    pe.CTA
  ), H = (R) => h[R].initial, j = (R) => E ? h[R].onLoad : h[R].onScroll, Ve = () => _ ? Oe[_] : E ? at : 0;
  S(() => {
    m && (_ ? _ === q.enter ? x(!0) : _ === q.leave && x(!1) : x(!1));
  }, [m, _]);
  const ee = _e((R) => $e(R));
  return /* @__PURE__ */ a(
    lt,
    {
      tabIndex: -1,
      "aria-hidden": "true",
      href: ge(i || "", T, w),
      id: c,
      className: g,
      "data-pa-click": r && Ue,
      onMouseLeave: () => ee(q.leave),
      ...u,
      children: /* @__PURE__ */ b(
        Pe,
        {
          transition: {
            delay: Ve(),
            ...st
          },
          children: [
            /* @__PURE__ */ b(
              A,
              {
                className: C.getElementClassName("qr-code-section"),
                id: d.qrCodeSection,
                initial: H(d.qrCodeSection),
                animate: j(d.qrCodeSection),
                onMouseEnter: () => ee(q.enter),
                children: [
                  /* @__PURE__ */ a(
                    A,
                    {
                      initial: h[d.qrCodeSectionBackground].initial,
                      animate: j(d.qrCodeSectionBackground),
                      id: d.qrCodeSectionBackground,
                      className: C.getElementClassName(
                        "qr-code-section-background"
                      )
                    }
                  ),
                  /* @__PURE__ */ b("div", { className: C.getElementClassName("qr-code-wrapper"), children: [
                    /* @__PURE__ */ a(
                      "div",
                      {
                        className: C.getElementClassName(
                          "qr-code-image-wrapper"
                        ),
                        children: /* @__PURE__ */ a(
                          Q,
                          {
                            className: C.getElementClassName("qr-code"),
                            fallbackImageUrl: o,
                            imageAltText: s,
                            variant: "small",
                            dataUrl: l,
                            qrSizes: it
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ a(
                      A,
                      {
                        initial: h[d.qrCodeText].initial,
                        animate: j(d.qrCodeText),
                        id: d.qrCodeText,
                        className: C.getElementClassName("qr-code-text"),
                        children: /* @__PURE__ */ a(Ge, { size: "Body Bold", children: t })
                      }
                    )
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ a(Y, { mode: "wait", children: M && E && /* @__PURE__ */ b(
              "div",
              {
                id: d.bodyTextSection,
                className: C.getElementClassName("body-text-section"),
                children: [
                  /* @__PURE__ */ a(
                    A,
                    {
                      initial: H(d.bodyTextBackground),
                      animate: h[d.bodyTextBackground].onLoad,
                      exit: h[d.bodyTextBackground].onScroll,
                      id: d.bodyTextBackground,
                      className: C.getElementClassName(
                        "body-text-background"
                      )
                    }
                  ),
                  /* @__PURE__ */ a(
                    "div",
                    {
                      id: d.bodyTextWrapper,
                      className: C.getElementClassName(
                        "body-text-wrapper"
                      ),
                      children: /* @__PURE__ */ a(
                        A,
                        {
                          initial: H(d.bodyText),
                          animate: h[d.bodyText].onLoad,
                          exit: h[d.bodyText].onScroll,
                          id: d.bodyText,
                          children: e && /* @__PURE__ */ a(
                            "div",
                            {
                              className: C.getElementClassName("body-text"),
                              children: /* @__PURE__ */ a(
                                V,
                                {
                                  content: e,
                                  lineProps: {
                                    analyticsCompName: r
                                  }
                                }
                              )
                            }
                          )
                        }
                      )
                    }
                  )
                ]
              }
            ) })
          ]
        }
      )
    }
  );
};
Se.displayName = K;
const dt = {
  "sticky-qr-animated": "_sticky-qr-animated_96svn_1"
}, X = "StickyQrAnimated", mt = new v(X, dt), pt = (n) => {
  const { imageUrl: t, qrCodeText1: e, text: o } = n;
  return !!(t && e && G(o));
}, ut = U(fe), Te = ({
  sectionIdToHide: n = "cta-stacked-closing",
  className: t,
  ...e
}) => {
  const {
    requestor: { clientInfo: { clientType: o = oe.dedicated } = {} } = {},
    environment: { isRTL: s = !1 } = {}
  } = O(), { foundationTheme: i } = de(Ce), c = o === oe.dedicated && pt(e), r = qe(), m = be(), { variant: l, aboutToExit: p, transition: u } = W({
    reduceMotion: r
  }), { showQrCode: g } = nt(n), N = y(
    mt.getComponentClassName(),
    i,
    t
  ), T = !p && g;
  return c ? /* @__PURE__ */ a(he, { children: /* @__PURE__ */ a(Y, { mode: "wait", children: T && /* @__PURE__ */ a(
    ut,
    {
      initial: l.initial,
      exit: l.exit,
      transition: u,
      position: s ? "bottom left" : "bottom right",
      className: N,
      children: /* @__PURE__ */ a(
        Se,
        {
          ...e,
          reduceMotion: r,
          analyticsCompName: X,
          scrollDirection: m
        }
      )
    }
  ) }) }) : null;
};
Te.displayName = X;
const yt = "DesktopView", ve = ({
  analyticsCompName: n,
  classNameGen: t,
  closeButtonAriaLabel: e,
  imageAltText: o,
  imageUrl: s,
  dataQrUrl: i,
  onClose: c,
  text: r
}) => {
  const m = t.getElementClassName("desktop-view"), l = t.getElementClassName("desktop-view-image"), p = y(
    Z.getThemeClassName("white"),
    t.getElementClassName("desktop-view-text")
  );
  return /* @__PURE__ */ b("div", { className: m, children: [
    /* @__PURE__ */ a(
      Q,
      {
        variant: "small",
        dataUrl: i,
        fallbackImageUrl: s,
        className: l,
        imageAltText: o
      }
    ),
    r && /* @__PURE__ */ a("div", { className: p, children: /* @__PURE__ */ a(
      V,
      {
        content: r,
        lineProps: {
          analyticsCompName: n
        }
      }
    ) }),
    /* @__PURE__ */ a(
      Ne,
      {
        analyticsCompName: n,
        closeAriaLabel: e,
        iconClick: () => c(),
        inverse: !0
      }
    )
  ] });
};
ve.displayName = yt;
const gt = "MobileView", we = ({
  analyticsCompName: n,
  classNameGen: t,
  closeButtonAriaLabel: e,
  cta: o,
  onClose: s
}) => {
  if (!o || !o.text)
    return null;
  const i = t.getElementClassName("mobile-view"), c = y(
    Z.getThemeClassName("white"),
    t.getElementClassName("mobile-button")
  );
  return /* @__PURE__ */ b("div", { className: i, children: [
    /* @__PURE__ */ a(
      Ye,
      {
        ...o,
        analyticsCompName: n,
        className: c
      }
    ),
    /* @__PURE__ */ a(
      Ne,
      {
        analyticsCompName: n,
        closeAriaLabel: e,
        iconClick: () => s(),
        inverse: !0
      }
    )
  ] });
};
we.displayName = gt;
const z = "sticky-qr-badge-close-date", _t = 1, Ct = 1e3, qt = Ct * 60, bt = qt * 60, ht = bt * 24, Nt = ({
  ctaMobile: n,
  text: t,
  imageUrl: e,
  imageAltText: o,
  className: s,
  badgeCloseTimeoutDays: i = _t,
  analyticsCompName: c,
  closeButtonAriaLabel: r,
  dataQrUrl: m,
  classNameGen: l,
  foundationTheme: p
}) => {
  const [u, g] = f(!1);
  S(() => {
    const w = We(z);
    if (w) {
      const M = Number(w), E = (/* @__PURE__ */ new Date()).getTime(), x = M + ht * i;
      E >= x && (g(!0), Ze(z));
    } else
      g(!0);
  }, [i]);
  const N = () => {
    Ke(z, (/* @__PURE__ */ new Date()).getTime().toString()), g(!1);
  }, T = y(
    l.getComponentClassName(),
    s,
    p
  );
  return u ? /* @__PURE__ */ b("div", { className: T, children: [
    /* @__PURE__ */ a(
      ve,
      {
        analyticsCompName: c,
        classNameGen: l,
        closeButtonAriaLabel: r,
        imageAltText: o,
        imageUrl: e,
        onClose: N,
        text: t,
        dataQrUrl: m
      }
    ),
    /* @__PURE__ */ a(
      we,
      {
        analyticsCompName: c,
        classNameGen: l,
        closeButtonAriaLabel: r,
        cta: n,
        onClose: N
      }
    )
  ] }) : null;
}, xt = (n) => {
  const [t, e] = f(!1);
  return S(() => {
    const o = new IntersectionObserver(
      ([i]) => {
        if (i.isIntersecting)
          e(!0);
        else {
          const { bottom: c } = i.boundingClientRect, r = c < 0;
          e(r);
        }
      },
      { threshold: 0 }
    ), s = n.current;
    return s && o.observe(s), () => {
      s && o.unobserve(s);
    };
  }, [n]), t;
}, kt = "FeaturedCtaSection", ft = 300, St = () => {
  const n = te(null), t = te(void 0), e = xt(n), [o, s] = f(!1);
  return S(() => {
    t.current = !!document.getElementById(kt);
  }, []), S(() => {
    Xe(() => {
      const c = !!(e && t.current);
      s(c);
    }, ft)();
  }, [e]), [n, o];
}, Tt = le(
  ({
    href: n = "",
    "aria-hidden": t,
    tabIndex: e,
    componentId: o,
    linkText: s,
    analyticsCompName: i,
    children: c,
    ...r
  }, m) => {
    const {
      environment: { pageSegment: l = "", baseURI: p = "" } = {},
      requestor: { locality: { country: u = "" } = {} } = {}
    } = O(), g = me(
      {
        linkText: s,
        componentName: i,
        linkType: ue.Tertiary,
        clickEvent: ye.GetTheApp
      },
      l,
      pe.CTA
    );
    return /* @__PURE__ */ a(
      "a",
      {
        ref: m,
        tabIndex: e,
        "aria-hidden": t,
        href: ge(n, p, u),
        id: o,
        "data-pa-click": i && g,
        ...r,
        children: c
      }
    );
  }
), Ee = "QrComponent", se = {
  large: 210,
  small: 84
}, B = {
  mainQRContent: "qr-component-animation-id-content",
  qrContainerSmall: "qr-component-animation-id-small",
  qrContainerLarge: "qr-component-animation-id-large"
}, vt = 1500, ie = {
  image: "https://www.paypalobjects.com/marketing/web/us/test-demo/qr-stealth/paypal-mark-black.svg",
  options: {
    margin: 4
  }
}, Re = `.${B.mainQRContent}`, Be = `.${B.qrContainerSmall}`, F = `.${B.qrContainerLarge}`, Ie = [0, 0, 0.25, 1], Me = {
  duration: 0.6,
  ease: Ie
}, I = {
  duration: 0.4,
  ease: Ie
}, wt = 2.5, Et = 1.5, $ = Et * wt, Ae = 0.4, Rt = () => [
  [
    F,
    {
      opacity: 1
    },
    { ...I, at: 0 }
  ],
  [
    Re,
    {
      opacity: 0
    },
    { ...I, at: 0 }
  ],
  [
    Be,
    {
      opacity: 0
    },
    { ...I, at: 0 }
  ]
], Bt = () => [
  [
    F,
    {
      scale: [Ae, 1],
      x: [`${$}rem`, "0rem"],
      y: [`${$}rem`, "0rem"]
    },
    { ...Me }
  ]
], It = () => [
  [
    F,
    {
      scale: [1, Ae],
      x: ["0rem", `${$}rem`],
      y: ["0rem", `${$}rem`]
    },
    Me
  ]
], Mt = () => [
  [
    F,
    {
      opacity: 0
    },
    I
  ],
  [Be, { opacity: 1 }, { ...I, at: 0 }],
  [Re, { opacity: 1 }, { ...I, at: 0 }]
], At = (n) => {
  const [t, e] = Je(), o = ne(async () => {
    await e(Rt()), await e(Bt());
  }, [e]), s = ne(async () => {
    await e(It()), await e(Mt());
  }, [e]);
  return S(() => {
    n ? o() : s();
  }, [e, n, o, s]), { scope: t, scaleUp: o, scaleDown: s };
}, Lt = "_slideInFromBottom_15ev3_1", Qt = "_collapsed_15ev3_102", L = {
  "qr-component": "_qr-component_15ev3_1",
  "qr-component-content": "_qr-component-content_15ev3_42",
  "qr-component-entry-animation": "_qr-component-entry-animation_15ev3_53",
  slideInFromBottom: Lt,
  "qr-component-qr-container": "_qr-component-qr-container_15ev3_58",
  "qr-component-qr-container-large": "_qr-component-qr-container-large_15ev3_69",
  "qr-component-text-container": "_qr-component-text-container_15ev3_84",
  "qr-component-body-text": "_qr-component-body-text_15ev3_94",
  collapsed: Qt
}, k = new v(Ee, L), $t = ({
  className: n,
  animateStickyEnd: t = !1,
  imageUrl: e,
  imageAltText: o,
  text: s,
  dataQrUrl: i,
  analyticsCompName: c,
  ariaHidden: r
}) => {
  const [m, l] = f(""), [p, u] = f(!0), { aboutToExit: g } = W(), N = be(), { scope: T } = At(t), w = !N || m === q.enter, M = y(k.getComponentClassName(), n, {
    [k.getElementClassName("entry-animation")]: p,
    [L.collapsed]: !w,
    [L.animate]: t
  }), x = _e((_) => {
    t || l(_);
  });
  return S(() => {
    const _ = setTimeout(
      () => u(!1),
      vt
    );
    return () => clearTimeout(_);
  }, []), g ? /* @__PURE__ */ a(
    "div",
    {
      className: y(k.getComponentClassName(), L.collapsed)
    }
  ) : /* @__PURE__ */ b(
    "div",
    {
      ref: T,
      className: M,
      onMouseLeave: () => x(q.leave),
      onMouseEnter: () => x(q.enter),
      "aria-hidden": r,
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            className: y(
              B.mainQRContent,
              k.getElementClassName("content")
            ),
            children: s && /* @__PURE__ */ a("div", { className: k.getElementClassName("text-container"), children: /* @__PURE__ */ a("div", { className: k.getElementClassName("body-text"), children: /* @__PURE__ */ a(
              V,
              {
                content: s,
                lineProps: {
                  analyticsCompName: c,
                  customWrapper: xe({ size: "Body Large Bold" })
                }
              }
            ) }) })
          }
        ),
        /* @__PURE__ */ a(
          Q,
          {
            className: y(
              B.qrContainerSmall,
              k.getElementClassName("qr-container")
            ),
            fallbackImageUrl: e,
            imageAltText: o,
            variant: "small",
            dataUrl: i,
            qrSizes: se,
            backgroundOptions: { color: "black" },
            dotsOptions: { color: "white", type: "dots" },
            ariaHidden: t
          }
        ),
        /* @__PURE__ */ a(
          Q,
          {
            className: y(
              B.qrContainerLarge,
              k.getElementClassName("qr-container-large")
            ),
            fallbackImageUrl: e,
            imageAltText: o,
            variant: "large",
            image: ie.image,
            imageOptions: ie.options,
            dataUrl: i,
            qrSizes: se,
            backgroundOptions: { color: "transparent" },
            dotsOptions: { color: "black", type: "dots" },
            ariaHidden: !t
          }
        )
      ]
    }
  );
}, Dt = "_animate_hn6fa_34", Le = {
  "qr-component": "_qr-component_hn6fa_1",
  "qr-component-body-text": "_qr-component-body-text_hn6fa_30",
  animate: Dt
}, ce = new v(Ee, Le), Ot = ({
  animateStickyEnd: n,
  qrCodeText1: t,
  text: e,
  analyticsCompName: o,
  ariaHidden: s
}) => {
  const i = y(ce.getComponentClassName(), {
    [Le.animate]: n
  });
  return /* @__PURE__ */ a("div", { className: i, "aria-hidden": s, children: /* @__PURE__ */ a("div", { className: ce.getElementClassName("body-text"), children: /* @__PURE__ */ a(
    V,
    {
      content: t || e,
      lineProps: {
        analyticsCompName: o,
        customWrapper: xe({ size: "Body Bold" })
      }
    }
  ) }) });
}, Ut = "QrComponent", Vt = ({
  className: n,
  qrCodeText1: t = "",
  text: e,
  imageUrl: o,
  imageAltText: s = "",
  url: i,
  componentId: c = "sticky-qr-badge",
  analyticsCompName: r = Ut,
  dataQrUrl: m,
  animateStickyEnd: l = !1
}) => {
  const { viewportType: p } = et(), u = ["xs", "sm", "md"].includes(p);
  return /* @__PURE__ */ b(
    Tt,
    {
      href: i,
      className: n,
      analyticsCompName: r,
      componentId: c,
      linkText: t,
      children: [
        /* @__PURE__ */ a(
          $t,
          {
            animateStickyEnd: l,
            dataQrUrl: m,
            imageUrl: o,
            imageAltText: s,
            text: e,
            analyticsCompName: r,
            ariaHidden: u
          }
        ),
        /* @__PURE__ */ a(
          Ot,
          {
            animateStickyEnd: l,
            qrCodeText1: t,
            text: e,
            analyticsCompName: r,
            ariaHidden: !u
          }
        )
      ]
    }
  );
}, Ft = "_wrapper_1wuz2_1", Ht = "_animate_1wuz2_30", P = {
  wrapper: Ft,
  "sticky-qr-stealth": "_sticky-qr-stealth_1wuz2_10",
  animate: Ht,
  "sticky-qr-stealth-anchor": "_sticky-qr-stealth-anchor_1wuz2_34"
}, D = "StickyQrStealth", re = new v(D, P), jt = (n) => {
  const { imageUrl: t, qrCodeText1: e, text: o } = n;
  return !!(t && e && G(o));
}, zt = U.div, Qe = ({
  className: n,
  theme: t = "black",
  ...e
}) => {
  const o = qe(), [s, i] = St(), { aboutToExit: c, transition: r } = W({
    reduceMotion: o
  }), m = y(P.wrapper, n, {
    [Z.getThemeClassName(t)]: !!t
  }), l = y(re.getComponentClassName(), {
    [P.animate]: i
  }), p = jt(e), u = !c;
  return p ? /* @__PURE__ */ b(he, { children: [
    /* @__PURE__ */ a("div", { id: `${D}Sentinel`, ref: s }),
    /* @__PURE__ */ a("section", { className: m, style: { backgroundColor: "unset" }, children: /* @__PURE__ */ a(Y, { mode: "wait", children: u && /* @__PURE__ */ a(
      zt,
      {
        exit: {
          opacity: 0
        },
        transition: r,
        className: l,
        children: /* @__PURE__ */ a(
          Vt,
          {
            reduceMotion: o,
            analyticsCompName: D,
            animateStickyEnd: i,
            className: re.getElementClassName("anchor"),
            ...e
          }
        )
      }
    ) }) })
  ] }) : null;
};
Qe.displayName = D;
const J = "StickyQRBadge", Pt = new v(J), Gt = ({
  ctaMobile: n,
  text: t,
  imageUrl: e,
  imageAltText: o,
  className: s,
  badgeCloseTimeoutDays: i,
  analyticsCompName: c = J,
  closeButtonAriaLabel: r,
  dataQrUrl: m
}) => {
  const { foundationTheme: l } = de(Ce);
  return l === "quantum-leap" || l === "quantum-leap-supreme" ? /* @__PURE__ */ a(
    Te,
    {
      className: l,
      dataQrUrl: m,
      text: t,
      imageUrl: e,
      imageAltText: o,
      qrCodeText1: n.text,
      url: n.url
    }
  ) : l === "ppe" ? /* @__PURE__ */ a(
    Qe,
    {
      className: l,
      dataQrUrl: m,
      text: t,
      imageUrl: e,
      imageAltText: o,
      qrCodeText1: n.text,
      url: n.url
    }
  ) : /* @__PURE__ */ a(
    Nt,
    {
      className: s,
      foundationTheme: l,
      analyticsCompName: c,
      classNameGen: Pt,
      closeButtonAriaLabel: r,
      imageAltText: o,
      imageUrl: e,
      text: t,
      dataQrUrl: m,
      ctaMobile: n,
      badgeCloseTimeoutDays: i
    }
  );
};
Gt.displayName = J;
export {
  Gt as default
};
//# sourceMappingURL=StickyQRBadge.js.map
